var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreatment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "13_\u5C31\u8BCA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58,29.19,34.84,6a4,4,0,0,0-5.66,0L6,29.19a4,4,0,0,0,0,5.66l23.2,23.2a4,4,0,0,0,5.66,0L58,34.85A4,4,0,0,0,58,29.19ZM42,34H34v8a2,2,0,0,1-4,0V34H22a2,2,0,0,1,0-4h8V22a2,2,0,0,1,4,0v8h8a2,2,0,0,1,0,4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreatment);
export default __webpack_public_path__ + "static/media/treatment.decd504d.svg";
export { ForwardRef as ReactComponent };